<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- MainView -->
      <article @click.self="open = false" :class="{ 'full-column' : !open }" class="wrapper wrapper-content main-column">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
          <h1 class="info-menu view-name">
            <img src="static/img/assets/nav_1on1_on.png" alt="">
            {{$t('oneOnHistoryTileType')}}
          </h1>
          <span class="info-right">
            <button @click="histryDelete" type="button" class="btn btn-danger block m-b">{{$t('oneRequestClearStr')}}</button>
          </span>
        </div>
        <!-- /ViewTitleBox -->
        <section class="animated fadeInRight">
          <template>
            <!-- 1on1item -->
            <div class="ibox">
              <div class="ibox-content flex-option">

                <div v-if="!getCurrent1on1sRequest.send1on1" class="ibox-child one-child cursor">
                  <div class="history-item">
                    <span class="one-item-text">
                        {{$t('notFoundOneRequest')}}
                    </span>
                  </div>
                </div>


                <div v-for="sentItem in getCurrent1on1sRequest.send1on1" :key="sentItem.id" @click="onClickSentItem(sentItem)" class="ibox-child one-child cursor">
                  <div class="flex-box cursor">
                    <img class="one-icon" src="static/img/assets/nav_1on1_on.png" alt="">
                    <div class="comment">
                      <div class="flex-box fl-between">
                        <h4 class="h3">{{$t('oneRequest')}}</h4>
                        <div><span class="info-comment-detail">
                          <span>{{ sentItem.createdAt | preparedTime }}</span>
                        </span></div>
                      </div>
                      <div><span>{{ getRequestsByNoticeType(sentItem) }}</span></div>
                    </div>
                  </div>
                </div>

                <!-- <div v-for="sentItem in getCurrent1on1sRequest.send1on1" :key="sentItem.id" @click="onClickSentItem(sentItem)" class="ibox-child one-child cursor">
                  <div class="child-tools">
                    <span class="info-menu">
                      <h4 class="h4"><img class="one-icon" src="static/img/assets/nav_1on1_on.png" alt="">{{$t('oneOnTileType')}}</h4>
                    </span>
                    <span class="info-time">
                      <span>{{ sentItem.createdAt | preparedTime }}</span>
                    </span>
                  </div>
                  <div class="history-item">
                    <span class="one-item-text">
                      <span>{{ getUsers[sentItem.userId].userInfo.userName }}</span>{{$t('sendOneOnRequestMsgString')}}
                    </span>
                  </div>
                </div> -->


              </div>
              <!-- /ibox-content -->
          </div>
          <!-- /1on1item -->
        </template>

      </section>
    </article>

      <!-- DetailView -->
      <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
        <div class="close-content"><div @click="open = false" class="close-btn cursor"><i class="fa fa-angle-right"></i></div></div>
        <article class="sub-content-wrap">
          <section class="inner-wrap">
            <div class="s-inner-wrap">
              <div class="ibox-title flex-box fl-between ibox-detail-header">
                <span class="info-menu flex-box">{{$t('oneOnRequestListTileType')}}</span>
                <span class="info-right"></span>
              </div>
              <div v-if="this.targetSentItem && this.targetSentItem.contentText" class="ibox">
                <div class="ib-sub-content">
                    <div class="ibox-title">
                        <h4 class="h3"><label class="request-header">{{$t('rtfbRegConfigTileType')}}</label>{{ getLatestTargetUserName }}</h4>
                    </div>
                    <div class="ibox-child detail-head">
                        <p class="font-bold">{{ $t('commentLabelTitle') }}</p>
                        <p v-html="this.targetSentItem.contentText" v-linkified:options="{validate: httpValidation}">
                        <!--<read-more :text="this.targetSentItem.contentText" :addMore="true" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight">-->
                        <!--</read-more>-->
                        </p>
                    </div>
                </div>
              </div>
            </div>
          </section>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import linkify from 'vue-linkify'
import OneSentItem from '@/components/One/OneSentItem'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'
import moment from 'moment'

export default {
  name: 'OneRequestSent',
  components: {
    OneSentItem,
    ReadMore
  },
  directives: {
    linkified: linkify
  },
  data: function () {
    return {
      httpValidation: {
        url: function (value) {
          return /^(http)s?:\/\//.test(value)
        }
      },
      tag: 'progress',
      open: false,
      targetSentItem: {},
      propShowMore: false,
      propContentHeight: 0
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'OneRequestSent'
    },
    ...mapGetters([
      'getUserId'
    ]),
    ...mapGetters('ones/', [
      'getCurrent1on1sRequest'
    ]),
    ...mapGetters('users/', [
      'getUserInfoById'
    ]),
    sendOneOnRequestMsgString () { return this.$t('sendOneOnRequestMsgString') },
    getLatestTargetUserName: function () {
      if (
        this.targetSentItem.userId &&
        this.getUserInfoById(this.targetSentItem.userId)
      ) {
        return this.getUserInfoById(this.targetSentItem.userId).userName
      } else {
        return this.targetSentItem.userId || ''
      }
    }
  },
  methods: {
    ...mapActions('ones/', {
      removeSendHistry: 'REMOVE_SEND_1ON1S'
    }),
    onClickSentItem: function (sentItem) {
      this.targetSentItem = sentItem
      if (!this.open) {
        this.open = true
      }
    },
    histryDelete: function () {
      const $t = this.$t
      if (Object.keys(this.getCurrent1on1sRequest).filter(x => x === 'send1on1').length === 1) {
        this.$swal({
          // sweetAlartの処理
          title: $t('popTitleStrType'),
          text: $t('doDeleteStr'),
          showCancelButton: true,
          cancelButtonColor: '#f64846',
          type: 'warning',
          confirmButtonClass: 'btn btn-success',
          cancelButtonClass: 'btn btn-danger',
          reverseButtons: false,
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          allowOutsideClick: false,
          padding: '2rem'
          // timer: 3000
        }).then((result) => {
          if (result.value) {
            console.log('isDelete = true')
            console.log(this.getUserId)
            this.removeSendHistry(this.getUserId)
            this.$swal({
              title: $t('compDeleteStr'),
              type: 'success',
              animation: false,
              customClass: 'animated fadeInUp',
              // customClass: 'animated flipInX',
              width: '35rem',
              position: 'center',
              // toast: true,
              padding: '2rem',
              timer: 3000
            })
            if (this.open) {
              this.open = false
            }
          } else {
            console.log('isDelete = false')
            console.log(Object.keys(this.getCurrent1on1sRequest))
          }
        })
      } else {
        this.$swal({
          title: $t('notExistOneRequestStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      }
    },
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      this.propContentHeight = value
    },
    getRequestsByNoticeType (sentItem) {
      console.log('getRequestsByNoticeType:::sentItem:::', sentItem)
      let contentText
      if (this.getUserInfoById(sentItem.userId)) {
        contentText = this.sendOneOnRequestMsgString.replace('{$user}', this.getUserInfoById(sentItem.userId).userName)
      } else {
        contentText = sentItem.userName + this.sendOneOnRequestMsgString
      }
      console.log('getRequestsByNoticeType:::contentText:::', contentText)
      return contentText
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flex-option{
    display: flex;
    flex-direction: column-reverse;
  }
  .ibox-child:first-of-type {
    border-top: solid 1px #e7eaec;
  }
  .ibox-child:last-of-type {
    border-top: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/views/one/OneRequestSent.vue